import angular from 'angular';

export default angular.module('shared').constant('userTypeConstants', {
    undefined: 0,
    user: 1,
    passthrough: 2
});



// WEBPACK FOOTER //
// ./modules/shared/constants/userType.constant.js